import Base, { baseInit } from './base';

export class TargetingTypeAllocation extends Base {
  id = null; // Integer
  TargetingType = null; // String
  TargetingLevel = null; // Integer

  constructor(data) {
    super(data);
    baseInit(this, data);
  }
}
